<template>
  <div>
    <v-row>
      <v-col cols="4" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-4"
         v-model="editedItem.systemId" label="System ID" readonly />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-4"
         v-model="editedItem.mainCurrentOwnerName" readonly
          label="Owner Name" />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-4"
         v-model="editedItem.mainSitusAddress" readonly
         label="Situs Address" />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
         v-model="editedItem.mainTaxId" label="Tax ID" readonly />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <v-text-field class="input-text-size ma-0 pa-0 mt-n2" readonly
         v-model="editedItem.mainPropertyOrParcelId" label="Property ID" />
      </v-col>
    </v-row>
    <CRUDList ref="crudList" :canAdd="true" :headers="headers"
      :displayTopPagination="false" :canEdit="true"
      :canSave="true" :showDate="true" :showDialog="true"
      :disablePagination="true" :hideDefaultFooter="true"
      :enableFixedHeaders="true" :baseCrudKey="baseCrudKeyAdditionalTable"
      :defaultSortBy="defaultSortBy" dialogDynamicWidth="30vw"
      tableWrapperDynamicClassname="pa-1 pb-5 taxroll-table-wrapper"
      tableDynamicClassname="taxroll-custom-table" tableDynamicHeight="130"
      :createNewItem="createNewItem"
      @upsertItem="upsertTransaction">
      <template v-slot:[`editedItem`]="{ }">
        <AdditionalNameAddressesDialog :baseCrudKey="baseCrudKeyAdditionalTable" />
      </template>
      <template v-slot:[`additionalActionsAfterDelete`]="{}">
        <v-btn class="input-text-size" text
         :disabled="!editedItemForAdditionalTable.isItManuallyAdded"
          color="error darken-1" @click="deleteRecord()">
          Delete
        </v-btn>
    </template>
    </CRUDList>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { juneResaleNameAndAddressesHeader } from '../../../deliquentUtils/deliquent.utils';
import CRUDList from '../../../../../common/base/crud-2.0/CRUDList.vue';
import AdditionalNameAddressesDialog from './AdditionalNameAddressesDialog.vue';
import '../../../../../../assets/style.css';

export default {
  name: 'AdditionalNameAddressesList',
  props: {
    baseCrudKey: {
      type: String,
      default: 'baseCrudKeyAdditional',
    },
    baseCrudKeyAdditionalTable: {
      type: String,
      default: 'baseCrudKeyAdditionalTable',
    },
  },
  data() {
    return {
      headers: juneResaleNameAndAddressesHeader,
    };
  },
  components: {
    CRUDList,
    AdditionalNameAddressesDialog,
  },
  computed: {
    ...mapGetters('base/crud', ['items', 'item']),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    editedItemForAdditionalTable: {
      get() {
        return this.item(this.baseCrudKeyAdditionalTable);
      },
      set(value) {
        this.setItem([this.baseCrudKeyAdditionalTable, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'taxId',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('tax/taxPayment', [
      'setSelectedItemsBelowTable',
    ]),
    onSingleClicked() {
      this.$emit('handleDialogItem');
    },
    upsertTransaction(item) {
      this.$emit('upsertTransaction', item);
    },
    deleteRecord() {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.$emit('deleteRecord', this.editedItemForAdditionalTable);
      }
    },
    createNewItem() {
      return {
        printCertifiedMailer: true,
      };
    },
  },
};
</script>
